module.exports = __webpack_public_path__ + "/images/logo-cta-murcia-alpha.63b0143.png";